import productSelect from './product-select';
import bindTableActions from './table-save';
import bindNotificationActions from './table-notifications';
import { clearNotifications, addNotification } from './table-notifications';

(async () => {
	await productSelect();
	await bindTableActions();
	bindNotificationActions();
	quoteTablePost();
	bindDropdowns();
})();

const quoteBtn = document.querySelector('#quote-it');

/**
 * Bind click on Add to Quote button
 */
const quoteTablePost = () => {
	const itemInputs = document.querySelectorAll('input.table-field');
	if (!quoteBtn) {
		return;
	}

	// Click on Add to Quote button
	quoteBtn.addEventListener('click', async (e) => {
		e.stopPropagation();
		clearNotifications();

		// Loop through all items and add them.
		// For some reason, if these requests are made concurrently, items are sometimes not added to the quote.
		// So this uses await for each one to complete.
		for (let index = 0; index < itemInputs.length; index++) {
			const item = itemInputs[index];
			const itemID = item.getAttribute('value');
			// Make POST request to add item
			if (itemID) {
				await tableToQuote(itemID); 
			}
		}

		// Add notification about adding to quote
		addNotification('The items on your design have been added to <a href="/request-quote/"><b>your quote</b></a>.', ['success']);

	}, false);
};

/**
 * Convert single item from tabletop design into a quote. Makes POST request.
 * @param   {integer}  itemId  Product Post ID
 * @return  {Promise}
 */
const tableToQuote = async (itemId = 0) => {
	if (typeof itemId == 'undefined' || itemId == null || itemId == 0){
		return Promise.resolve();
	}

	// Create query params. This uses the action in the YITH request a quote plugin. For reference:
	//    add_to_quote_action() -- Add an item in the list from query string.
	//    for example ?add-to-quote=%product_id%&quantity=%quantity%
	let params = {
		'add-to-quote': itemId,
		quantity: 1,
		noTemplate: true
	};

	let query = Object.keys(params)
		.map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
		.join('&');

	// Make POST request to add item.
	// Note: also works making a request to '/' URL, but this returns page data. Use custom endpoint instead:
	try {
		const response = await fetch(`/`, {
			method: 'POST',
			body: query,
			headers: { 'Content-type': 'application/x-www-form-urlencoded' },
			credentials: 'same-origin'
		});

		// Remove focus from button
		if (document.activeElement instanceof HTMLElement){
			document.activeElement.blur();
		}
		return Promise.resolve();
	} catch (error) {
		// Catches errors both in fetch and response.json
		console.error('Error with request to add items to quote.', error);
		return Promise.resolve();
	}
};


/**
 * Bind custom dropdowns (for mobile "Actions" button)
 */
const bindDropdowns = () => {
	const drop = document.querySelector('.pr-drop');
	if (drop !== null){
		drop.addEventListener('click', (e) => {
			e.stopPropagation();

			// Toggle class on parent
			const dropParent = drop.parentElement;
			if (dropParent !== null){
				if (!dropParent.classList.contains('pr-drop-open')){
					dropParent.classList.add('pr-drop-open');
				} else {
					dropParent.classList.remove('pr-drop-open');
				}
			}
		}, false);
	}
}